import { render, staticRenderFns } from "./DetailsCategory.vue?vue&type=template&id=9cabac2a&scoped=true"
import script from "./DetailsCategory.vue?vue&type=script&lang=js"
export * from "./DetailsCategory.vue?vue&type=script&lang=js"
import style0 from "./DetailsCategory.vue?vue&type=style&index=0&id=9cabac2a&prod&scoped=true&lang=css"
import style1 from "./DetailsCategory.vue?vue&type=style&index=1&id=9cabac2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cabac2a",
  null
  
)

export default component.exports